import { GuestComponent } from './Views/Guest/guest.component';
import { NoAuthLoginComponent } from './Components/Authentication/signin-method-noAuth.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StartupService } from './Services/app/startup.service';
import { SharedModule } from './appShares.module';
// import { MatomoModule } from 'ngx-matomo';
import { SignInComponent } from './Components/Authentication/signin.component';
import { SmsLoginComponent } from './Components/Authentication/signin-method-sms.component';
import { IframeSignInComponent } from './Components/Authentication/signin-method-iframe.component';
import { RegistrationComponent } from './Components/registration.component.component';
import { DocumentSignComponent } from './Components/document-sign.component';
import { SigninMethodEhelseComponent } from './Components/Authentication/signin-method-ehelse';
import { AudioPlayerComponent } from './Common/Components/audio-player/audio-player.component';
import { UnitPickerComponent } from './Components/unit-picker.component';
import { BreadcrumbsComponent } from './Components/breadcrumbs.component';
import { IndexComponent } from './Views/Index/index.component';
import { ComponentsComponent } from './Views/Develop/components.component';
import { MobileAppPromotionComponent } from './Components/mobile-app-promotion.component';
import { ProxyRedirectComponent } from './Views/ProxyRedirect/ProxyRedirect.component';
import { EmbeddedWebComponent } from './Components/embedded-web.component';
import { APP_BASE_HREF } from '@angular/common';
import { UrlSerializer } from '@angular/router';
import { CustomUrlSerializer } from './Classes/customUrlSerializer';
import { SpaContext } from './Classes/spacontext';
import { SpaLogger } from './Common/Classes/Global/spalogger.class';
import { ExternalSvgComponent } from './Components/externalSvg.component';
import { WrappersModule } from 'Public_old/src/wrappers/wrappers.module';
import { DropInSectionFromMenuComponent } from './Components/drop-in-section-from-menu.component';
import { NonSupportedBrowser } from './Components/non-supported-browser.component';

export function startupServiceFactory(startupService: StartupService): Function {
	return () => startupService.load();
}
export function getBaseLocation() {
	return document.querySelector('base').attributes.getNamedItem('href').value;
}

// const matomoId = location.hostname.includes('vcare.pl') || location.hostname.includes('stage-service') ? 1 : 4;

@NgModule({
	imports: [
		BrowserModule,
		AppRoutingModule,
		SharedModule.forRoot(),
		// MatomoModule.forRoot({
		// 	scriptUrl: '//analytics.visibacare.com/matomo.js',
		// 	trackers: [
		// 		{
		// 			trackerUrl: '//analytics.visibacare.com/matomo.php',
		// 			siteId: matomoId,
		// 		},
		// 	],
		// }),
		WrappersModule,
	],
	declarations: [
		// directives, components, and pipes owned by this NgModule
		// Components
		AppComponent,

		SignInComponent,
		SmsLoginComponent,
		NoAuthLoginComponent,
		IframeSignInComponent,
		RegistrationComponent,
		DocumentSignComponent,
		SigninMethodEhelseComponent,
		GuestComponent,
		ExternalSvgComponent,
		NonSupportedBrowser,

		AudioPlayerComponent,
		UnitPickerComponent,
		BreadcrumbsComponent,
		DropInSectionFromMenuComponent,

		IndexComponent,
		ComponentsComponent,
		MobileAppPromotionComponent,
		ProxyRedirectComponent,
		EmbeddedWebComponent,
	],
	providers: [
		StartupService,
		{
			provide: APP_INITIALIZER,
			useFactory: startupServiceFactory,
			deps: [StartupService],
			multi: true,
		},
		{
			provide: APP_BASE_HREF,
			useFactory: () => '',
		},
		{ provide: UrlSerializer, useClass: CustomUrlSerializer },
	],
	bootstrap: [AppComponent],
})
export class AppModule {
	constructor(
		public spaContext: SpaContext,
		private spaLogger: SpaLogger,
	) {
		if (typeof µ.isDevelopment !== 'undefined' && µ.isDevelopment) this.spaLogger.logLevel = 3;
	}
}
